import type { FrequentlyOrderProduct } from '~/api/model';
import { useMembershipStatus } from '~/app/hooks';

/**
 * 상품 가격 컴포넌트 분기 종류.
 *
 * - membershipWeek: 플멤 스탠다드 유저 + priceBadge === 'MEMBERSHIP_WEEK'
 * - luckyBonusPack: 플멤 스탠다드 유저 + priceBadge === 'LUCKY_BONUS_PACK'
 * - membershipStandardNudge: 논플멤 + 현재 할인 + 스탠다드 멤버십 넛지 할인가가 현재할인가보다 더 큼
 * - couponDiscounted: 쿠폰 할인이 적용된 "나의할인가" (플멤/논플멤 공용)
 * - noDiscount: 할인 없는 판매가
 *
 * 분기 조건이 바뀌면 이 훅만 수정하고, 각 호출처의 `switch` 에
 * variant 가 추가/수정될 때 컴파일 에러로 안내되도록 유지한다.
 */
export type ProductPriceVariant =
  | 'membershipWeek'
  | 'luckyBonusPack'
  | 'membershipStandardNudge'
  | 'couponDiscounted'
  | 'noDiscount';

export function useProductPriceVariant(
  data: FrequentlyOrderProduct,
): ProductPriceVariant {
  const { isMembershipStandard } = useMembershipStatus();
  const { priceBadge, totalDiscountAmount, nudgeTotalDiscountedPrice } = data;

  if (isMembershipStandard) {
    if (priceBadge === 'MEMBERSHIP_WEEK') return 'membershipWeek';
    if (priceBadge === 'LUCKY_BONUS_PACK') return 'luckyBonusPack';
    return 'couponDiscounted';
  }

  if (nudgeTotalDiscountedPrice) return 'membershipStandardNudge';
  if (!totalDiscountAmount) return 'noDiscount';

  return 'couponDiscounted';
}
